const configuracoesPaletteColors = [
    { background: '#FFEBEE', text: '#C62828' }, // rosa claro
    { background: '#E8F5E9', text: '#2E7D32' }, // verde claro
    { background: '#E3F2FD', text: '#1565C0' }, // azul claro
    { background: '#FFF3E0', text: '#EF6C00' }, // laranja claro
    { background: '#F3E5F5', text: '#6A1B9A' }, // roxo claro
];

/**
 * Retorna uma palete de cores pastel baseado no id.
 */
export const getColorById = (id: number) => {
    const hash = Array.from(String(id)).reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const index = hash % configuracoesPaletteColors.length;

    return configuracoesPaletteColors[index];
};
